import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "", once = true, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", delay = 0, as: Tag = "span" }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className="block"
          initial={{ y: "110%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1.1, delay: delay + i * 0.14, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const SectionHeading = ({ eyebrow, title, subtitle, align = "left", light = false, id }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <span className="eyebrow" data-testid={id ? `${id}-eyebrow` : undefined}>{eyebrow}</span>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`h2 mt-4 ${light ? "text-cream" : ""}`} data-testid={id ? `${id}-title` : undefined}>{title}</h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.16}>
        <p className={`mt-6 text-base leading-relaxed ${light ? "text-cream/70" : "text-muted"}`}>{subtitle}</p>
      </Reveal>
    )}
  </div>
);
